import { oc } from '@orpc/contract';
import { z } from 'zod';

export const SubmitEgovApplicationByStepInstanceInputSchema = z.object({
  operationStepInstanceId: z.string(),
  govProfileId: z.string(),
});

export const SubmitEgovApplicationByStepInstanceOutputSchema = z.object({
  egovApplicationId: z.string(),
  arriveId: z.string(),
  applicationSubmittedAt: z.string(),
});

export const submitEgovApplicationByStepInstanceContract = oc
  .route({
    method: 'POST',
    path: '/v2/boe/packages/HRF_LABOR_CORE/step-instances/{operationStepInstanceId}/egov-submit',
  })
  .input(SubmitEgovApplicationByStepInstanceInputSchema)
  .output(SubmitEgovApplicationByStepInstanceOutputSchema);

export type SubmitEgovApplicationByStepInstanceInput = z.infer<
  typeof SubmitEgovApplicationByStepInstanceInputSchema
>;
export type SubmitEgovApplicationByStepInstanceOutput = z.infer<
  typeof SubmitEgovApplicationByStepInstanceOutputSchema
>;

export const laborCoreEgovSubmitContract = oc.router({
  submitByStepInstance: submitEgovApplicationByStepInstanceContract,
});
